import {useQuery, gql} from '@apollo/client'

const useAllPlansByService = (vars = {}) => {
    return useQuery(
        gql`query(
            $serviceId: ID!
            $kinds: [PlanKind!]
            ){
            allActivePlansByService(
            serviceId: $serviceId
                kinds: $kinds
                ) {
              id
              name
            }
        }`,
        {
            variables: vars
        }
    )
}

export default useAllPlansByService